import React from 'react';
import { isMediumViewport } from '../../Hooks/useMedia';
import PhoneHoursNumbersList from './numbers-list';
import ScheduleList from '../components/Schedule/List';
import ScheduleTable from '../components/Schedule/Table';

const PhoneHours = (props) => (
  <div className="phonehours">
    {props.Phone && props.Phone?.map((phoneNumber, index) => (
      <div className="phonehours__container" key={index}>
        <div className="phonehours__numbers">
          {phoneNumber.Title && (
            <div className="contact-card__item__label">
              {phoneNumber.Title}
            </div>
          )}
          {phoneNumber.Numbers && (
            <PhoneHoursNumbersList
              Linkable={phoneNumber.Linkable}
              Numbers={phoneNumber.Numbers}
              IsEmail={phoneNumber.IsEmail}
            />
          )}
        </div>
        {phoneNumber.Schedule && (
          <div className="phonehours__info">
            {props.Translations.phonehours && (
              <div className="contact-card__item__label">
                {props.Translations.phonehours}
              </div>
            )}
            {!isMediumViewport() ? (
              <ScheduleTable
                {...phoneNumber}
                Translations={props.Translations}
              />
            ) : (
              <ScheduleList
                List={phoneNumber.Schedule}
                Translations={props.Translations}
              />
            )}
          </div>
        )}
      </div>
    ))}
  </div>
);

export default PhoneHours;
